import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { Endpoints } from '../../services/endpoints';
import { CdxApiGatewayHttpService } from '../../../shared/services/cdx-api-gateway-http.service';

export interface ArmMegaSecurity {
  cusip: string;
  originalFaceAmount: number;
}

export interface ValidateArmPoolRequest {
  reportingPeriod: string;
  collateralGroupNumber: number;
  detailed: boolean;
  securites: ArmMegaSecurity[];
}

export interface ValidateArmPoolResponse {
  outputDirectory: string;
  filesWritten: string[];
  replineCount: number;
  poolCount: number;
  megaCount: number;
  summaryText: string;
  warnings: unknown[];
}

@Injectable({
  providedIn: 'root',
})
export class ValidateArmPoolService {
  private http = inject(CdxApiGatewayHttpService);

  public generateReport(payload: ValidateArmPoolRequest): Observable<ValidateArmPoolResponse> {
    return this.http.post(Endpoints.VALIDATE_ARM_POOL_OUTPUT_FILES_ENDPOINT, payload, {
      overrideErrorHandler: true,
    });
  }
}
